import React, { useRef, useEffect } from 'react';
import { gsap } from '../../../../gsap';
import './Gloves.scss';

function FutureGloves({ screenWidth }) {
  const futureGlovesText = useRef();
  const futureGlovesCanvas = useRef();
  const futureGlovesSection = useRef();
  const futureGlovesAnimation = useRef();

  useEffect(() => {
    // set canvas properties
    const canvas = futureGlovesCanvas.current.getContext('2d');
    // Set the size of the canvas
    futureGlovesCanvas.current.height = futureGlovesAnimation.current.clientHeight;
    futureGlovesCanvas.current.width = futureGlovesAnimation.current.clientHeight * 0.56;
    const frameCount = 42;
    // Count the frames and set the path to the images
    const currentFrame = (index) =>
      `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/future/gloves/ACCESS_HAND_${(
        index + 1
      )
        .toString()
        .padStart(2, '0')}.png`;

    // Set start frame
    const images = [];
    const target = {
      frame: 0
    };

    // Go through frames from start to finish
    const anim = gsap.timeline({
      scrollTrigger: {
        trigger: futureGlovesSection.current,
        start: 'top top',
        endTrigger: futureGlovesSection.current,
        end: 'bottom bottom',
        scrub: 1
      }
    });
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }
    anim.add('start').to(
      target,
      {
        frame: frameCount - 1,
        snap: 'frame',
        duration: 2,
        ease: 'linear',
        onUpdate: render
      },
      'start'
    );
    images[0].onload = render;
    function render() {
      canvas.clearRect(0, 0, futureGlovesCanvas.current.width, futureGlovesCanvas.current.height);
      canvas.drawImage(
        images[target.frame],
        0,
        0,
        futureGlovesCanvas.current.width,
        futureGlovesCanvas.current.height
      );
    }
  }, [screenWidth]);

  return (
    <section className="gloves gloves-future" ref={futureGlovesSection}>
      <div className="gloves__animation gloves__animation-future" ref={futureGlovesAnimation}>
        <canvas className="gloves__animation__canvas" ref={futureGlovesCanvas} />
      </div>
      <div className="gloves__text gloves__text-future" ref={futureGlovesText}>
        <h3 className="gloves__text__title gloves__text__title-future">Robotic Actuators</h3>
        <p className="gloves__text__copy">
          Gloves may include robotic actuators to support finger movement, knuckle joints for
          increased range of motion, and/or finger buckles for better sizing.
        </p>
      </div>
    </section>
  );
}

export default FutureGloves;
